import { EmailContentType, EmailEditorVersion } from "@simplyk/common";
import { TReaderDocument } from "@usewaypoint/email-builder";

import { AttachmentInput } from "@/common/types/email";

export interface EmailContentFormData {
  subject: string;
  previewText: string;
  senderName: string;
  body: string;
  attachment: AttachmentInput;
  designConfig: TReaderDocument | Record<string, string | number>;
  emailType: EmailContentType | null;
  replyToUserId: string | null;
  deliveryMode: "schedule" | "send";
  scheduledFor: string | null;
  scheduleOffset: number | null;
  editorVersion: EmailEditorVersion | null;
  wasConverted?: boolean;
}

export const CUSTOM_HTML_STRIPPED_TAGS = ["iframe", "script", "object", "embed"] as const;
export type CustomHtmlStrippedTag = (typeof CUSTOM_HTML_STRIPPED_TAGS)[number];

export type CustomHtmlStrippedTagCounts = Record<CustomHtmlStrippedTag, number>;

export interface AuditErrors {
  placeholderImage: number;
  buttonWithoutLink: number;
  videoWithoutLink: number;
  socialsWithoutLink: number;
  blockedLinkShortener: number;
}

export const EMPTY_CUSTOM_HTML_STRIPPED_TAG_COUNTS: CustomHtmlStrippedTagCounts = {
  iframe: 0,
  script: 0,
  object: 0,
  embed: 0,
};

export const EMPTY_AUDIT_ERRORS: AuditErrors = {
  placeholderImage: 0,
  buttonWithoutLink: 0,
  videoWithoutLink: 0,
  socialsWithoutLink: 0,
  blockedLinkShortener: 0,
};
